<!-- 属性管理 -->
<template>
    <div class="container">
        <div class="content">
            <div>
                <Button
                    class="theme-bc mb24 theme-default-color"
                    icon="md-add-circle"
                    @click="goModal(1)"
                    >新增属性</Button
                >
                <Table
                    ref="selection"
                    :columns="columnsTable"
                    :data="dataTable"
                    border
                    @on-selection-change="changeSelection"
                >
                    <template slot-scope="{ row }" slot="content_count">
                        <div class="flex-c" @click="goAttribute(row)">
                            <Button>{{
                                row.content_count ? row.content_count : 0
                            }}</Button>
                        </div>
                    </template>
                    <template slot-scope="{ row }" slot="operate">
                        <div class="flex-sa">
                            <Button
                                type="primary"
                                ghost
                                @click="goModal(1, row)"
                                >编辑</Button
                            >
                            <Button type="error" ghost @click="goDel(1, row)"
                                >删除</Button
                            >
                        </div>
                    </template>
                </Table>
            </div>
            <div class="page">
                <div>
                    <Checkbox
                        class="checkbox-ml"
                        v-model="del_value"
                        @on-change="handleSelectAll"
                        >全选</Checkbox
                    >
                    <span class="mr24 ml24"
                        >已经选择{{ delData.length }}个</span
                    >
                    <Button type="error" ghost @click="goDel(0)">删除</Button>
                </div>
                <Page
                    :current="storePrams.page"
                    :page-size="storePrams.limit"
                    :total="total"
                    show-elevator
                    show-total
                    @on-change="pageChange"
                />
            </div>
        </div>
        <!-- 属性字段 -->
        <Modal
            v-model="attributeModal"
            title="属性字段"
            width="500"
            :mask-closable="false"
        >
            <div>
                <Button
                    class="theme-bc mb24 theme-default-color"
                    icon="md-add-circle"
                    @click="goModal(3)"
                    >新增属性字段</Button
                >
                <div class="flex-c">
                    <Form
                        :model="attributeData"
                        label-position="right"
                        :label-width="100"
                    >
                        <div
                            v-for="(item, index) in attributeData.names"
                            :key="index"
                        >
                            <FormItem :label="'字段名称' + (index + 1)">
                                <div class="flex-sb">
                                    <Input
                                        class="w250"
                                        type="text"
                                        v-model="item.attribute_name"
                                        placeholder="请输入字段名称"
                                    ></Input>
                                    <img
                                        class="ml12 cursor-p wh28"
                                        src="../../assets/modify.png"
                                        @click="goModal(3, item)"
                                    />
                                    <img
                                        class="ml12 cursor-p wh28"
                                        v-if="attributeData.names.length > 1"
                                        src="../../assets/delete.png"
                                        @click="goDel(2, item)"
                                    />
                                </div>
                            </FormItem>
                        </div>
                    </Form>
                </div>
            </div>
            <div slot="footer"></div>
        </Modal>
        <!-- 新增/编辑/添加属性字段 -->
        <Modal
            v-model="modals"
            :title="modalTitle"
            :width="modalWidth"
            :mask-closable="false"
        >
            <div>
                <template v-if="modalID == 1">
                    <Form
                        class="mt24"
                        :model="formData"
                        label-position="right"
                        :label-width="100"
                    >
                        <FormItem label="属性名称:">
                            <Input
                                type="text"
                                v-model="formData.name"
                                placeholder="请输入属性名称"
                            ></Input>
                        </FormItem>
                    </Form>
                </template>
                <template v-if="modalID == 3">
                    <Form
                        :model="formName"
                        label-position="right"
                        :label-width="100"
                    >
                        <FormItem label="字段类型:">
                            <Select
                                class="w200"
                                v-model="formName.attribute_type"
                                clearable
                                filterable
                                placeholder="请选择字段类型"
                            >
                                <Option
                                    v-for="item in typeList"
                                    :value="item.id"
                                    :key="item.id"
                                    >{{ item.name }}</Option
                                >
                            </Select>
                        </FormItem>
                        <FormItem label="字段名称:">
                            <Input
                                class="w200"
                                type="text"
                                v-model="formName.attribute_name"
                                placeholder="填写字段名称"
                            ></Input>
                            <Tooltip
                                max-width="250"
                                placement="right"
                                theme="light"
                            >
                                <Icon
                                    class="ml24 cursor-p"
                                    type="md-help-circle"
                                    size="20"
                                    color="var(--primary-color) "
                                />
                                <div slot="content">
                                    <p class="theme-color">如尺寸,颜色</p>
                                </div>
                            </Tooltip>
                        </FormItem>
                        <FormItem label="提示文字:">
                            <Input
                                class="w200"
                                type="text"
                                v-model="formName.attribute_tips"
                                placeholder="填写提示文字"
                            ></Input>
                            <Tooltip
                                max-width="250"
                                placement="right"
                                theme="light"
                            >
                                <Icon
                                    class="ml24 cursor-p"
                                    type="md-help-circle"
                                    size="20"
                                    color="var(--primary-color) "
                                />
                                <div slot="content">
                                    <p class="theme-color">
                                        用于对字段框内容的提示
                                    </p>
                                </div>
                            </Tooltip>
                        </FormItem>
                        <FormItem label="是否必填:">
                            <i-switch
                                v-model="formName.is_true"
                                size="large"
                                true-color="var(--primary-color) "
                                :true-value="1"
                                :false-value="2"
                            >
                                <span slot="open">开启</span>
                                <span slot="close">关闭</span>
                            </i-switch>
                        </FormItem>
                        <FormItem label="表单顺序:">
                            <Input
                                class="w200"
                                type="text"
                                v-model="formName.sort"
                                placeholder="请填写表单顺序"
                            ></Input>
                            <Tooltip
                                max-width="250"
                                placement="right"
                                theme="light"
                            >
                                <Icon
                                    class="ml24 cursor-p"
                                    type="md-help-circle"
                                    size="20"
                                    color="var(--primary-color) "
                                />
                                <div slot="content">
                                    <p class="theme-color">
                                        数字越大越靠前,建议填写0-100之间整数,默认值为1
                                    </p>
                                </div>
                            </Tooltip>
                        </FormItem>
                        <!-- 下拉列表框 单选框 复选框 -->
                        <FormItem
                            v-if="
                                formName.attribute_type == 3 ||
                                formName.attribute_type == 4 ||
                                formName.attribute_type == 5
                            "
                            label="字段类型值:"
                        >
                            <Input
                                class="w200"
                                type="textarea"
                                v-model="formName.type_val"
                                :autosize="{ minRows: 3 }"
                                placeholder="请输入字段值"
                            ></Input>
                            <Tooltip
                                max-width="250"
                                placement="right"
                                theme="light"
                            >
                                <Icon
                                    class="ml24 cursor-p"
                                    type="md-help-circle"
                                    size="20"
                                    color="var(--primary-color) "
                                />
                                <div slot="content">
                                    <p class="theme-color">多个选项用*分割</p>
                                </div>
                            </Tooltip>
                        </FormItem>
                        <!-- 图片 -->
                        <FormItem
                            v-if="formName.attribute_type == 6"
                            label="上传图片："
                        >
                            <div class="form-upload" @click="openModal">
                                <img
                                    class="wh100"
                                    v-if="formName.attribute_val"
                                    :src="formName.attribute_val"
                                />
                                <Icon
                                    v-else
                                    type="ios-add"
                                    size="44"
                                    color="#AEAEB3"
                                />
                            </div>
                        </FormItem>
                        <!-- 默认值 -->
                        <FormItem
                            v-if="
                                formName.attribute_type == 1 ||
                                formName.attribute_type == 2
                            "
                            label="默认值："
                        >
                            <Input
                                class="w200"
                                type="text"
                                v-model="formName.attribute_val"
                                placeholder="请输入默认值"
                            ></Input>
                        </FormItem>
                    </Form>
                </template>
            </div>
            <div slot="footer">
                <Button @click="cancelModal">取消</Button>
                <Button
                    class="theme-bc theme-default-color"
                    @click="submitModal"
                    >确定</Button
                >
            </div>
        </Modal>
        <pictureLibrary
            v-if="switch_modal"
            :switch_modal.sync="switch_modal"
            :select="select"
            @change="costPlannedAmountChange"
        ></pictureLibrary>
    </div>
</template>

<script>
import {
    product_attribute_list,
    product_attribute_save,
    product_attribute_del,
    product_attribute_content_list,
    product_attribute_content_save,
    product_attribute_content_del,
} from "@/api/index";
import pictureLibrary from "@/components/pictureLibrary/pictureLibrary.vue";
export default {
    components: { pictureLibrary },
    data() {
        return {
            select: 1,
            switch_modal: false,
            storePrams: {
                page: 1,
                limit: 10,
            },
            total: 0,
            columnsTable: [
                { type: "selection", width: 60, align: "center" },
                { title: "属性名称", key: "name", align: "center" },
                { title: "属性字段", slot: "content_count", align: "center" },
                { title: "更新时间", key: "updated_at", align: "center" },
                {
                    title: "操作",
                    slot: "operate",
                    align: "center",
                    width: "200px",
                },
            ],
            dataTable: [],
            attributeModal: false,
            modals: false,
            formData: {
                name: "",
                id: "",
            },
            modalTitle: "",
            modalID: "",
            modalWidth: "",
            attributeData: {
                names: [],
            },
            formName: {
                attribute_id: "",
                attribute_type: "",
                attribute_name: "",
                attribute_tips: "",
                is_true: "",
                sort: "1",
                type_val: "",
                id: "",
                attribute_val: "",
            },
            typeList: [
                { id: 1, name: "单行文本框" },
                { id: 2, name: "多行文本框" },
                { id: 3, name: "下拉列表框" },
                { id: 4, name: "单选框" },
                { id: 5, name: "复选框" },
                { id: 6, name: "图片" },
            ],
            // selection
            del_id: "",
            delData: [],
            del_value: false,
        };
    },
    mounted() {
        this.getList();
    },
    methods: {
        // 事件处理函数
        async costPlannedAmountChange(param1, param2) {
            for (var i = 0; i < param1.length; i++) {
                this.formName.attribute_val = param1[i];
            }
            this.$Message.destroy();
        },
        openModal() {
            this.switch_modal = true;
        },
        getList() {
            product_attribute_list(this.storePrams)
                .then((res) => {
                    this.dataTable = res.data.data;
                    this.total = res.data.total;
                    // 删除后，page--
                    if (!res.data.data.length && this.storePrams.page != 1) {
                        this.storePrams.page--;
                        this.getList();
                    }
                })
                .catch((err) => {
                    this.$Message.error(err.msg);
                });
        },
        pageChange(index) {
            this.storePrams.page = index;
            this.getList();
        },
        goSearch() {
            this.storePrams.page = 1;
            this.getList();
        },
        goDel(index, row) {
            if (index == 0 && this.delData.length == 0) {
                this.$Message.error("请选择");
                return;
            }
            this.$Modal.confirm({
                title: "删除提示",
                content: "确认删除吗？一经删除无法复原",
                onOk: () => {
                    if (index == 0) {
                        var del_id = [];
                        this.delData.forEach((item) => {
                            del_id.push(item.id);
                        });
                        this.del_id = del_id.join(",");
                        product_attribute_del({ id: this.del_id })
                            .then((res) => {
                                this.getList();
                                this.del_value = false;
                                this.$Message.success(res.msg);
                            })
                            .catch((res) => {
                                this.$Message.error(res.msg);
                            });
                    } else if (index == 1) {
                        product_attribute_del({ id: row.id })
                            .then((res) => {
                                this.getList();
                                this.$Message.success(res.msg);
                            })
                            .catch((res) => {
                                this.$Message.error(res.msg);
                            });
                    } else if (index == 2) {
                        product_attribute_content_del({ id: row.id })
                            .then((res) => {
                                this.getList();
                                this.getContentList();
                                this.modals = false;
                                this.$Message.success(res.msg);
                            })
                            .catch((res) => {
                                this.$Message.error(res.msg);
                            });
                    }
                },
                onCancel: () => {},
            });
        },
        getContentList() {
            product_attribute_content_list({ id: this.formName.attribute_id })
                .then((res) => {
                    this.attributeData.names = res.data;
                })
                .catch((err) => {
                    this.$Message.error(err.msg);
                });
        },
        goAttribute(row) {
            this.formName.attribute_id = row.id;
            this.getContentList();
            setTimeout(() => {
                this.attributeModal = true;
            }, 300);
        },
        goModal(index, row) {
            this.modalID = index;
            if (index == 1) {
                if (row) {
                    this.modalTitle = "编辑产品属性";
                    this.modalWidth = 500;
                    this.formData.id = row.id;
                    this.formData.name = row.name;
                } else {
                    this.modalTitle = "新增产品属性";
                    this.modalWidth = 500;
                    this.formData.id = "";
                    this.formData.name = "";
                }
            } else if (index == 3) {
                if (row) {
                    this.modalTitle = "编辑属性字段";
                    this.modalWidth = 500;
                    this.formName.attribute_id = row.attribute_id;
                    this.formName.attribute_type = row.attribute_type;
                    this.formName.attribute_name = row.attribute_name;
                    this.formName.attribute_tips = row.attribute_tips;
                    this.formName.is_true = row.is_true;
                    this.formName.sort = row.sort;
                    this.formName.type_val = row.type_val;
                    this.formName.id = row.id;
                    this.formName.attribute_val = row.attribute_val;
                } else {
                    this.modalTitle = "添加属性字段";
                    this.modalWidth = 500;
                    this.formName.attribute_type = 1;
                    this.formName.attribute_name = "";
                    this.formName.attribute_tips = "";
                    this.formName.is_true = 2;
                    this.formName.sort = "1";
                    this.formName.type_val = "";
                    this.formName.id = "";
                    this.formName.attribute_val = "";
                }
            }
            setTimeout(() => {
                this.modals = true;
            }, 200);
        },
        cancelModal() {
            this.modals = false;
        },
        // 确定
        submitModal() {
            if (this.modalID == 1) {
                product_attribute_save(this.formData)
                    .then((res) => {
                        this.getList();
                        this.modals = false;
                        this.$Message.success(res.msg);
                    })
                    .catch((res) => {
                        this.$Message.error(res.msg);
                    });
            } else if (this.modalID == 3) {
                if (
                    !this.formName.attribute_name ||
                    this.formName.attribute_name == 0
                ) {
                    this.$Message.error("请填写字段名称");
                    return;
                }
                product_attribute_content_save(this.formName)
                    .then((res) => {
                        this.getList();
                        this.getContentList();
                        this.modals = false;
                        this.$Message.success(res.msg);
                    })
                    .catch((res) => {
                        this.$Message.error(res.msg);
                    });
            }
        },
        // selection
        changeSelection(e) {
            this.delData = e;
            if (this.dataTable.length === e.length) {
                this.del_value = true;
            } else {
                this.del_value = false;
            }
        },
        handleSelectAll(e) {
            if (e == true) {
                this.delData = this.dataTable;
                this.$refs.selection.selectAll(true);
            } else {
                this.$refs.selection.selectAll(false);
            }
        },
    },
};
</script>

<style scoped>
.container {
    display: flex;
    flex-direction: column;
}
.content {
    padding: 24px;
    background: #ffffff;
    box-shadow: 0px 0px 4px 0px rgba(82, 102, 136, 0.1);
    border-radius: 5px;
    height: 100%;
}
.page {
    margin-top: 24px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    white-space: nowrap;
}
.w250 {
    width: 250px;
}
.wh28 {
    width: 28px;
    height: 28px;
}
.form-upload {
    width: 70px;
    height: 70px;
    background: #ffffff;
    border-radius: 5px;
    border: 1px dashed #9fa5bb;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
}
.wh100 {
    width: 100%;
    height: 100%;
}
.checkbox-ml {
    margin-left: 20px !important;
}
.cursor-p {
    cursor: pointer;
}
::v-deep .ivu-checkbox-checked .ivu-checkbox-inner {
    border-color: var(--primary-color);
    background-color: var(--primary-color);
}
/* 表头字体颜色 */
::v-deep .ivu-table-wrapper .ivu-table .ivu-table-header tr th {
    color: #484e66 !important;
    font-weight: bold;
}
/* table中所有的边框  */
::v-deep .ivu-table td {
    border-left: none;
    border-right: none;
}
::v-deep .ivu-table th {
    border-left: none;
    border-right: none;
}
</style>